import { gql } from "../gql";
import "./fragments";

export const WORKERS_QUERY = gql(`
  query Workers($salonId: ID!, $filters: WorkerFilterInput) {
    workers(salonId: $salonId, filters: $filters) {
      workers {
        ...WorkerDetail @unmask
      }
      pagination {
        ...Pagination @unmask
      }
    }
  }
`);

export const WORKER_QUERY = gql(`
  query Worker($salonId: ID!, $id: ID!) {
    worker(salonId: $salonId, id: $id) {
      ...WorkerDetail @unmask
    }
  }
`);

export const CREATE_WORKER_MUTATION = gql(`
  mutation CreateWorker($salonId: ID!, $input: CreateWorkerInput!) {
    createWorker(salonId: $salonId, input: $input) {
      ...WorkerDetail @unmask
    }
  }
`);

export const UPDATE_WORKER_MUTATION = gql(`
  mutation UpdateWorker($salonId: ID!, $workerId: ID!, $input: UpdateWorkerInput!) {
    updateWorker(salonId: $salonId, workerId: $workerId, input: $input) {
      ...WorkerDetail @unmask
    }
  }
`);

export const DELETE_WORKER_MUTATION = gql(`
  mutation DeleteWorker($salonId: ID!, $workerId: ID!) {
    deleteWorker(salonId: $salonId, workerId: $workerId)
  }
`);

export const WORKER_AVAILABILITY_QUERY = gql(`
  query WorkerAvailability($workerId: ID!, $salonId: ID!, $date: DateTime!) {
    workerAvailability(workerId: $workerId, salonId: $salonId, date: $date) {
      workerId
      availableSlots {
        start
        end
      }
    }
  }
`);
